// Utilitário para identificar se o arquivo é um vídeo
export function isVideoTypeUtils(filename: string): boolean {
  if (!filename) return false;
  return /\.(mp4|mov|avi|webm|mkv|m4v)$/i.test(filename);
} 